import { EnumMapper, ResolvedEnum } from "../../../../common/tables/etc/EnumMapper";

export class ConditionIsBundleMapper implements EnumMapper {
    public map(): ResolvedEnum {
        return {
            "true": {
                label: "Yes",
                value: "true",
                color: "neutral"
            },
            "false": {
                label: "No",
                value: "false",
                color: "neutral"
            },
        };
    }
}
